import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom"
import NewAddress from "./Stepper/NewAddress";
import Stepper from "./Stepper/Stepper";
import { useForm } from "react-hook-form";
import CartItems from "./CartItems"
import { useSelector, useDispatch } from "react-redux";
import { loggedInUser } from "../Auth/Auth_Slice";
import { Navigate } from "react-router-dom";
import { fetchUserAddressesAsync } from "../User/userSlice"
import { createNewOrderAsync } from "../Order/orderSlice";
import { userAddresses, userInfo, isLoadingUserSlice, addUserNewAddressAsync, fetchLoggedInUserOrdersAsync } from "../User/userSlice";
import Loader from "../../components/Common/Loader";
import toast from "react-hot-toast";
import { savedTempOrder } from "../Order/orderSlice";

const formatNumber = (number) => {
    if (number) {
        let x = number;
        x = x.toString();
        let lastThree = x.substring(x.length - 3);
        let otherNumbers = x.substring(0, x.length - 3);
        if (otherNumbers !== '')
            lastThree = ',' + lastThree;
        let res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
        return res;
    }
}

function Checkout() {
    //Selector from states 
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const loginFlow = searchParams.get('loginFlow');

    const user = useSelector(loggedInUser);
    const orders = useSelector((state) => state.user.userOrders);


    const loggedInUserDetails = useSelector(userInfo);
    const customerAddress = useSelector(userAddresses);
    const isLoading = useSelector(isLoadingUserSlice);
    const [addressIsFetchted, setAddressIsFetchted] = useState(false);


    const items = useSelector(state => state.cart.items);
    const actualPrice = items?.reduce((amount, item) => item.price * item.quantity + amount, 0)
    const cartItemsLength = useSelector(state => state.cart.itemsLength);

    //Steps States
    const [currentStep, setCurrentStep] = useState(1);
    const [stepCompleted, setStepCompleted] = useState([]);

    const { register, handleSubmit, reset, watch, getFieldState, formState: { errors, isValid, isSubmitting, submitCount } } = useForm();
    const selectedPaymentMethod = watch("paymentMethod"); //For final submit button text
    const dispatch = useDispatch()
    const navigate = useNavigate()

    //For Smooth Scrolling Effects Ref's
    const newAddressBox = useRef();
    const deliveryAddress = useRef();
    const orderSummary = useRef();
    const paymentSection = useRef();


    //Functions 
    const handleNext = (index) => {
        if (index > 0 && index <= 4) {
            setCurrentStep(prev => prev + 1)
            setStepCompleted(oldArray => [...oldArray, index]);
        }
    }

    const handleResetStep = async (step) => {
        setCurrentStep(step);
        setStepCompleted(stepCompleted.filter(value => value < step));
        if (step === 1) {
            await reset();
            handleAddressBackToFetched()
        }
    }

    //Display The Selected Radio Button Address
    const selectedAddress = customerAddress?.find(
        (address) => address.id === watch('address')
    );


    //Use Effects

    useEffect(() => {
        if (user !== null && user.isAuthenticated) {
            setCurrentStep(2);
            setStepCompleted([1]);
        }
        //run only when loginFLow is false and loginFLow exist
        if (loginFlow !== null && loginFlow !== true) {
            //if user click on buy now button then we will direct goes to step 3
            if (customerAddress.length === 0) {
                dispatch(fetchUserAddressesAsync()).then(() => {
                    setAddressIsFetchted(() => !addressIsFetchted);
                })
            }
            setCurrentStep(3);
            setStepCompleted([1, 2]);
            orderSummary.current.scrollIntoView({ behavior: "smooth" });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loginFlow]);



    useEffect(() => {
        if (customerAddress.length === 0 && currentStep === 2) {
            dispatch(fetchUserAddressesAsync()).then(() => {
                setAddressIsFetchted(() => !addressIsFetchted);
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentStep, dispatch]);


    //Form Submission Steps
    const validate = (data) => {
        //For step 1 i created a seperate function
        if (currentStep === 2) {
            if (data && data.address === "NEWADDRESS") {
                delete data["address"] // just for reference  to do: id hatani hai
                dispatch(addUserNewAddressAsync(data)).then(() => {
                    handleAddressBackToFetched();
                })
            } else {
                handleNext(2);
                orderSummary.current.scrollIntoView({ behavior: "smooth" });
            }
        } else if (currentStep === 3) {
            handleNext(3);
            paymentSection.current.scrollIntoView({ behavior: "smooth" });
        } else if (currentStep === 4) {
            //Because i do not want to store whole product in order section i want to store only productId and quanity price which can be different for each customer
            const selectedItems = items.map(item => ({ productId: item.productId, quantity: item.quantity, price: item.price, color: item.color, size: item.size }));
            const order = { items: selectedItems, grandTotal: actualPrice, totalItems: cartItemsLength, paymentMethod: data.paymentMethod, shippingAddress: { ...selectedAddress }, status: 1 }

            dispatch(savedTempOrder(order)); // will set the temp order in redux state this is because payment gateway have multiple interface so i can access from anywhere

            //Will check cash on delivery or online-payment
            if (order && order.paymentMethod === "PAYBYCASH") {

                dispatch(createNewOrderAsync(order)).then(async (response) => {

                    if (response.payload.status === 'success') {
                        // Redirect to the order success page
                        reset();

                        if (orders.length === 0) {
                            await dispatch(fetchLoggedInUserOrdersAsync()) //Kynki agar user k order already fetch ho chuke to ye call nai hoga slice automatically new order add krdega agar orders empty h to check backend se check krna pdega ki user ke or bhi orders h ya nai to sync backend and frontend
                        }

                        navigate(`/order?status=success&order=${response.payload.message.orderId}`);

                    }
                    else {
                        // Handle other cases show an error message
                        // reset();
                        // const encodedMessage = encodeURIComponent(response.payload.message);
                        // navigate(`/order?status=failed&message=${encodedMessage}`);

                        toast.error(response.payload.message, { id: "error", duration: 5000 })
                    }
                })
            } else if (order && order.paymentMethod === "ONLINEPAYMENT") {
                navigate(`/stripe-checkout`);
            } else {
                toast.error("Something went wrong", { id: "error", duration: 5000 });
            }
        }
    }


    // Fetched User Address + New Address State
    const [newAddress, setnewAddress] = useState(false);
    const [newAddressClicked, setnewAddressClicked] = useState(false); //This will keep user can't unselect by anyhow add new address radio button
    const [couponSectionShow, setcouponSectionShow] = useState(false);

    const [couponApplied, setcouponApplied] = useState(false);
    const [couponDiscountInput, setcouponDiscountInput] = useState("");

    const handleNewAddress = () => {
        if (!newAddressClicked) {
            document.querySelectorAll('input[name="address"]').forEach((radio) => {
                radio.checked = false;
            });
            setnewAddress(true);
            newAddressBox && newAddressBox.current && newAddressBox.current.scrollIntoView({ behavior: "smooth" });
            setnewAddressClicked(true);
        }
    }

    const handleAddressBackToFetched = () => {
        if (document.getElementById("newAddressForm")) {
            reset(); // because newaddress ki values empty nai horai
            setnewAddress(false);
            setnewAddressClicked(false); //This will enable the add new form btn again
            deliveryAddress.current.scrollIntoView({ behavior: "smooth" });
        }
    }

    const handleDiscountCoupon = () => {
        let discountCode = "DIWALI"
        if (couponDiscountInput.length > 0) {
            if (couponDiscountInput === discountCode) {
                //update the cart value and display the discount
                setcouponApplied(true)
            }
        }
    }


    return (
        <>
            {!user && !user?.isAuthenticated && <Navigate to="/login" replace={true}></Navigate>}
            {!cartItemsLength && <Navigate to="/cart" replace={true}></Navigate>}
            <div className="bgCheckout" >
                <form onSubmit={handleSubmit(validate)} className="w-full">
                    <div className="lg:max-w-7xl px-4 pb-24 pt-4 lg:px-8 sm:px-6 py-16 mx-auto">
                        <div className='lg:gap-x-12 lg:items-start lg:grid lg:grid-cols-12'>
                            <section className='col-span-8 checkout'>
                                <section className="px-2 pt-4 pb-8">
                                    <Stepper currentStep={currentStep} completedStep={stepCompleted} />
                                </section>
                                <div className="w-full pb-3">  {/* Step 1 */}
                                    <div className={`pl-6 rounded-t-md py-[12px] ${stepCompleted.includes(1) ? "bg-gray-50 text-gray-500 border-b-[1px] border-gray-200" : currentStep === 1 ? "bg-indigo-600 text-white" : "text-gray-500  bg-transparent border-b-[1px] border-gray-300"}`}>
                                        <div className="flex items-center justify-between flex-wrap">
                                            <div className="flex items-center">
                                                <label className="w-4 h-4 inline-flex items-center justify-center bg-gray-200 rounded text-xs pr-[1px] font-medium text-indigo-600"> 1 </label>
                                                <h1 className={`text-sm  font-medium ml-2`}>ACCOUNT LOGIN</h1>
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={`w-5 ml-[4px] pb-[2px] ${stepCompleted.includes(1) ? "block" : "hidden"}`}> <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" /> </svg>
                                            </div>
                                            {stepCompleted.includes(1) &&
                                                <>
                                                    <button onClick={() => handleResetStep(1)} type="button" className="text-indigo-600 rateProductShadow text-sm font-medium px-4 py-1.5 mr-6 rounded border-[1px] border-gray-300" >CHANGE</button>
                                                    <div className="block py-2 lg:py-0 basis-full ">
                                                        <span className="mr-4 text-gray-900 text-sm font-bold uppercase">{loggedInUserDetails && loggedInUserDetails.firstname + " " + loggedInUserDetails.lastname}</span>
                                                        <span className="text-gray-900 text-sm font-medium">{loggedInUserDetails && loggedInUserDetails.email}</span>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </div>
                                    {/*Step 1 When Active  */}
                                    {currentStep === 1 &&
                                        <div className="px-3 py-4">
                                            <div className="flex flex-wrap flex-col-reverse sm:flex-row">
                                                <div className="space-y-3 flex flex-wrap flex-col basis-full sm:basis-8/12">
                                                    <div className="space-y-1">
                                                        <div className="flex items-center text-sm font-medium text-gray-500">
                                                            <span className="min-w-[50px]">Name:</span>
                                                            <span className="ml-[15px] text-gray-900 font-semibold uppercase">{loggedInUserDetails && loggedInUserDetails.firstname + " " + loggedInUserDetails.lastname}</span>
                                                        </div>
                                                        <div className="flex items-center text-sm font-medium text-gray-500">
                                                            <span className="min-w-[50px]">Email:</span>
                                                            <span className="ml-[15px] text-gray-900 font-semibold">{loggedInUserDetails && loggedInUserDetails.email}</span>
                                                        </div>
                                                    </div>
                                                    <div className="inline-block">
                                                        <Link to="/signout"><h2 className="text-sm font-semibold text-indigo-600">Logout & Sign in to another account</h2></Link>
                                                        <button onClick={() => handleNext(1)} className="px-3 my-4 py-2 text-sm font-medium block text-white bg-indigo-600 rounded-md border-[2px] border-indigo-600 hover:bg-indigo-700 focus:ring-4 focus:outline-none focus:ring-indigo-300 uppercase"> CONTIUNE CHECKOUT </button>
                                                    </div>
                                                </div>
                                                <div className="basis-full sm:basis-4/12 mb-4 sm:mb-0">
                                                    <p className="text-gray-500 text-xs font-medium">Advantanges Of Our Secure Login</p>
                                                    <div className="block mt-4 mb-2">
                                                        <div className="inline-flex items-center space-x-2">
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 text-indigo-600"> <path d="M12.378 1.602a.75.75 0 00-.756 0L3 6.632l9 5.25 9-5.25-8.622-5.03zM21.75 7.93l-9 5.25v9l8.628-5.032a.75.75 0 00.372-.648V7.93zM11.25 22.18v-9l-9-5.25v8.57a.75.75 0 00.372.648l8.628 5.033z" /> </svg>
                                                            <p className="text-gray-900 text-xs  font-semibold">Easily Track Orders</p>
                                                        </div>
                                                    </div>
                                                    <div className="block">
                                                        <div className="inline-flex items-center space-x-2">
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 text-indigo-600"> <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z" clipRule="evenodd" /> </svg>
                                                            <p className="text-gray-900 text-xs font-semibold">Wishlist, Reviews, Ratings and more.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p className="text-gray-500 text-xs font-medium">Please note that upon clicking "Logout" you will lose all items in cart and will be redirected to home page.</p>
                                        </div>
                                    }  {/* active end */}
                                </div>{/* Step 1 End*/}

                                <div className="w-full pb-3">{/* Step 2 Start*/}
                                    <>
                                        <div className={`pl-6 rounded-t-md py-[12px] ${stepCompleted.includes(2) ? "bg-gray-50 text-gray-500 border-b-[1px] border-gray-200" : currentStep === 2 ? "bg-indigo-600 text-white" : "text-gray-500 bg-transparent border-b-[1px] border-gray-300"}`}>
                                            <div className="flex items-center justify-between flex-wrap">
                                                <div className="flex items-center">
                                                    <label className="w-4 h-4 inline-flex items-center justify-center bg-gray-200 rounded text-xs pr-[1px] font-medium text-indigo-600"> 2 </label>
                                                    <h1 className={`text-sm  font-medium ml-2`}>DELIVERY ADDRESS</h1>
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={`w-5 ml-[4px] pb-[2px] ${stepCompleted.includes(2) ? "block" : "hidden"}`}> <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" /> </svg>
                                                </div>
                                                {stepCompleted.includes(2) && watch('address') &&
                                                    <>
                                                        <button onClick={() => handleResetStep(2)} type="button" className="text-indigo-600 rateProductShadow text-sm font-medium px-4 py-1.5 mr-6 rounded border-[1px] border-gray-300" >CHANGE</button>
                                                        <div className="block py-2 lg:py-0 basis-full ">
                                                            <span className="mr-4 text-gray-900 text-sm font-bold uppercase">{selectedAddress?.customerName}</span>
                                                            <span className="text-gray-900 text-sm font-medium uppercase">{`${selectedAddress?.customerAddress},${selectedAddress?.customerCity},${selectedAddress?.customerState}-${selectedAddress?.customerPincode} `}</span>
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                        {/*When Active Step 2  */}
                                        { /* Here i used the display none over conditional rendering because i want to maintain the radio button state*/
                                            <div className={currentStep === 2 ? "block scroll-m-52 lg:scroll-m-36" : "hidden"} ref={deliveryAddress}>
                                                {isLoading ? <div className="flex mt-5 mb-2 items-center justify-center"> <Loader /> </div>
                                                    :
                                                    !(customerAddress === null || customerAddress.length === 0) &&
                                                    <div className="px-3 py-4">
                                                        {customerAddress.map((address, index) => (
                                                            <div onClick={handleAddressBackToFetched} key={address.id} className="flex pl-3 pt-2 mb-2.5 items-start border-[1px] border-gray-200 rounded-md">
                                                                <input defaultChecked={index === 0} {...register("address", { "required": "Select Address" })} id={address.id} type="radio" value={address.id} name="address" className="w-4 h-4 mt-[2px] text-indigo-600 bg-gray-100 border-gray-300 focus:ring-indigo-600 focus:ring-1" />
                                                                <label htmlFor={address.id} className="cursor-pointer">
                                                                    <div className="flex pl-3 justify-start space-x-4 items-center">
                                                                        <p className="text-sm font-medium text-gray-900 uppercase">{address.customerName}</p>
                                                                        <div className={`px-2 py-0.5 text-xs rounded inline-flex items-center font-medium text-gray-400 bg-gray-200 uppercase`}> {address.addressType} </div>
                                                                        <p className="text-gray-900 text-sm font-semibold sm:pl-0 sm:p-0">{address.customerPhoneNo}</p>
                                                                    </div>
                                                                    <p className="text-gray-700 pl-3 my-2 text-sm font-medium block uppercase">{`${address.customerAddress} ${address.customerCity} ${address.customerState} ${address.customerPincode}`}</p>
                                                                </label>
                                                            </div>
                                                        ))}
                                                        {!newAddress &&
                                                            <div className="pt-1.5">
                                                                <button type="submit" className="px-3 py-2 text-sm font-medium block text-white bg-indigo-600 rounded-md border-[2px] border-indigo-600 hover:bg-indigo-700 focus:ring-4 focus:outline-none focus:ring-indigo-300 uppercase"> Deliver Here </button>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                <div onLoad={(addressIsFetchted && customerAddress.length === 0) ? handleNewAddress() : undefined} onClick={handleNewAddress} className={`pl-6 ${!newAddressClicked ? "cursor-pointer" : ""} rounded-t-md py-[12px] bg-transparent text-gray-500 border-b-[1px] border-gray-300 scroll-m-36 lg:scroll-m-16`} ref={newAddressBox}>
                                                    <div className="flex items-center justify-between flex-wrap">
                                                        <div className="flex items-center">
                                                            <label className="w-4 h-4 inline-flex items-center justify-center bg-gray-200 rounded text-base pr-[1px] font-medium text-indigo-600"> <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5"> <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" /> </svg></label>
                                                            <h1 className={`text-sm  font-medium ml-2`}>Add a new address</h1>
                                                        </div>
                                                    </div>
                                                </div>
                                                {newAddress && (
                                                    <div className="px-3 py-4" id="newAddressForm">
                                                        <input defaultChecked={newAddress} {...register("address")} id="newAddress" type="radio" value="NEWADDRESS" name="address" className="w-4 h-4 text-indigo-600 bg-gray-100 border-gray-300 focus:ring-indigo-600  focus:ring-1 " />
                                                        <label htmlFor="newAddress" className="mx-4 text-sm font-medium text-gray-900 uppercase">ADD A NEW ADDRESS</label>
                                                        <NewAddress errors={errors} isSubmitting={isSubmitting} submitCount={submitCount} getFieldState={getFieldState} register={register} cancelNewAddress={handleAddressBackToFetched} />
                                                    </div>
                                                )}
                                            </div>
                                        }
                                    </>
                                </div>  {/* active step 2 end */}

                                <div className="w-full pb-3" >
                                    <div className={`pl-6 rounded-t-md py-[12px] ${stepCompleted.includes(3) ? "bg-gray-50 text-gray-500 border-b-[1px] border-gray-200" : currentStep === 3 ? "bg-indigo-600 text-white" : "text-gray-500  bg-transparent border-b-[1px] border-gray-300"}`}>
                                        <div className="flex items-center justify-between flex-wrap">
                                            <div className="flex items-center scroll-m-[27rem] lg:scroll-my-80" ref={orderSummary}>
                                                <label className="w-4 h-4 inline-flex items-center justify-center bg-gray-200 rounded text-xs pr-[1px] font-medium text-indigo-600"> 3 </label>
                                                <h1 className={`text-sm  font-medium ml-2`}>ORDER SUMMARY</h1>
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={`w-5 ml-[4px] pb-[2px] ${stepCompleted.includes(3) ? "block" : "hidden"}`}> <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" /> </svg>
                                            </div>
                                            {stepCompleted.includes(3) &&
                                                <>
                                                    <button onClick={() => handleResetStep(3)} type="button" className="text-indigo-600 rateProductShadow text-sm font-medium px-4 py-1.5 mr-6 rounded border-[1px] border-gray-300">CHANGE</button>
                                                    <div className="block py-2 lg:py-0 basis-full ">
                                                        <span className="mr-4 text-gray-900 text-sm font-bold">{cartItemsLength} Items</span>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </div>

                                    {/*When Active  */}
                                    {currentStep === 3 &&
                                        <div className="px-3 py-1">
                                            <CartItems padding="py-4 sm:py-6" />
                                            <button type="submit" className="px-3 py-2  text-sm font-medium block text-white bg-indigo-600 rounded-md border-[2px] border-indigo-600 hover:bg-indigo-700 focus:ring-4 focus:outline-none focus:ring-indigo-300 uppercase mt-4"> Continue </button>
                                        </div>
                                    }
                                </div>{/* active end */}

                                {/*Step 4 Start  */}
                                <div className="w-full pb-3"  >
                                    <div className={`pl-6 rounded-t-md py-[12px] ${stepCompleted.includes(4) ? "bg-gray-50 text-gray-500 border-b-[1px] border-gray-200" : currentStep === 4 ? "bg-indigo-600 text-white" : "text-gray-500  bg-transparent border-b-[1px] border-gray-300"}`} >
                                        <div className="flex items-center justify-between flex-wrap" >
                                            <div className="flex items-center">
                                                <label className="w-4 h-4 inline-flex items-center justify-center bg-gray-200 rounded text-xs pr-[1px] font-medium text-indigo-600"> 4 </label>
                                                <h1 className={`text-sm  font-medium ml-2`}>PAYMENT OPTIONS</h1>
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={`w-5 ml-[4px] pb-[2px] ${stepCompleted.includes(4) ? "block" : "hidden"}`}> <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" /> </svg>
                                            </div>
                                        </div>
                                    </div>
                                    {/*Step 4 active  */}
                                    {currentStep === 4 &&
                                        <div className="px-3 py-4" >
                                            <div className="flex pl-3 pt-2 mb-2.5 items-start">
                                                <input defaultChecked {...register("paymentMethod", { "required": "Select payment" })} id={"paymentByCash"} type="radio" value={"PAYBYCASH"} className="w-4 h-4 mt-[2px] text-indigo-600 bg-gray-100 border-gray-300 focus:ring-indigo-600 focus:ring-1" />
                                                <label htmlFor={"paymentByCash"} className="cursor-pointer">
                                                    <div className="pl-3">
                                                        <p className="text-sm font-medium text-gray-900">Cash On Delivery</p>
                                                    </div>
                                                </label>
                                            </div>
                                            <div className="flex pl-3 pt-2 mb-2.5 items-start">
                                                <input {...register("paymentMethod", { "required": "Select payment" })} id={"onlinePayment"} type="radio" value={"ONLINEPAYMENT"} className="w-4 h-4 mt-[2px] text-indigo-600 bg-gray-100 border-gray-300 focus:ring-indigo-600 focus:ring-1" />
                                                <label htmlFor={"onlinePayment"} className="cursor-pointer">
                                                    <div className="pl-3">
                                                        <p className="text-sm font-medium text-gray-900">Pay Online - Secure Payment Method</p>
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                    }
                                    {/* Step 4 active end */}
                                </div>
                            </section>
                            <section aria-labelledby='summary-heading' className='mt-16 lg:sticky top-20 rounded-lg bg-gray-50 shadow-sm	px-4 py-4 sm:p-6 col-span-4	lg:mt-0 lg:p-8' ref={paymentSection}>
                                <h2 id="summary-heading" className="text-lg	font-medium text-gray-700">PRICE DETAILS</h2>
                                <div className="mt-6">
                                    <div className='flex justify-between items-center py-4'>
                                        <h3 className="text-base text-gray-600	">Price ({cartItemsLength} Items)</h3>
                                        <h3 className="text-base font-medium text-gray-900">₹{formatNumber(actualPrice)}</h3>
                                    </div>

                                    <div className='flex justify-between items-center border-gray-200	border-t-[1px] py-4'>
                                        {couponApplied ?
                                            <>
                                                <div className='flex items-center text-base text-gray-600	'>
                                                    <span>Coupon Discount</span>
                                                </div>
                                                <div className="flex">
                                                    <h3 className="text-base font-medium text-green-500">- ₹{199}</h3>
                                                    <Link onClick={() => setcouponApplied(false)} className="w-4 inline-flex justify-center items-center text-gray-400 ml-1">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.0} stroke="currentColor" className="w-4"> <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" /> </svg>
                                                    </Link>
                                                </div>
                                            </>
                                            :
                                            <>
                                                {couponSectionShow ?
                                                    <div className='w-full'>
                                                        <div class="relative">
                                                            <input type="text" onChange={(e) => setcouponDiscountInput(e.target.value)} id="COUPONDISCOUNT" class="block w-full p-3 text-sm text-gray-900 border border-gray-300 rounded-md bg-gray-50 focus:ring-indigo-600 focus:border-gray-300 foucs:ring-0" placeholder="Enter coupon code" spellCheck="false" />
                                                            <button type="button" onClick={handleDiscountCoupon} class="text-white absolute right-[5px] bottom-[5px] bg-indigo-600 hover:bg-indigo-700 focus:ring-2 focus:outline-none focus:ring-indigo-300 font-medium rounded-sm text-sm px-4 py-2">Apply</button>
                                                        </div>
                                                        <span className="text-xs text-red-600 pl-1">Invalid Promo code</span>
                                                    </div>
                                                    :
                                                    <>
                                                        <div className='flex items-center text-base text-gray-600	'>
                                                            <span>Coupon Code</span>
                                                        </div>
                                                        <Link to="#" onClick={() => setcouponSectionShow(true)} className="text-base font-medium text-green-500	">Apply Here</Link>
                                                    </>}
                                            </>

                                        }
                                    </div>

                                    <div className='flex justify-between items-center border-gray-200	border-t-[1px] py-4'>
                                        <div className='flex items-center text-base text-gray-600	'>
                                            <span>Delivery Charges</span>
                                            <Link to="#" className="ml-2 flex-shrink-0 text-gray-400	">
                                                <span className="whitespace-nowrapw-px	h-px p-0 overflow-hidden absolute bottom-0 m-1">Learn more about how shipping is calculated</span>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="h-5 w-5"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM8.94 6.94a.75.75 0 11-1.061-1.061 3 3 0 112.871 5.026v.345a.75.75 0 01-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 108.94 6.94zM10 15a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd"></path></svg>
                                            </Link>
                                        </div>
                                        <h3 className="text-base font-medium text-gray-900"><span className='text-gray-400 line-through'>₹110</span> <span className='text-green-500'>Free</span></h3>
                                    </div>

                                    <div className='flex justify-between items-center border-dashed border-gray-200	border-t-[1px] py-4'>
                                        <h3 className="text-lg font-medium text-gray-800">{currentStep === 4 ? "Amount Payable" : "Total Payable"} </h3>
                                        <h3 className="text-lg font-medium text-gray-800">₹{formatNumber(actualPrice)}</h3>
                                    </div>

                                </div>
                                <div className="mt-4 pb-3" >
                                    {currentStep === 4 && <button disabled={!isValid} type="submit" className="w-full uppercase rounded-md border-[1px] bg-indigo-600 hover:bg-indigo-700 focus:ring-4 focus:border-indigo-100 py-3 text-base font-medium text-white shadow-md" style={{ borderColor: "#0000" }}>{selectedPaymentMethod === "PAYBYCASH" ? "Place Order" : "Pay Online"}</button>}
                                </div>
                            </section>
                        </div>

                    </div>
                </form>
            </div>
        </>
    );
}

export default Checkout;